import { render, staticRenderFns } from "./CreateUserDialog.vue?vue&type=template&id=0f35c805&"
import script from "@/views/Contractors/Users/CreateUserDialog/CreateUserDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Contractors/Users/CreateUserDialog/CreateUserDialog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports